(function () {
  'use strict';

  function isCustomerLoggedIn() {
    return document.body.classList.contains('customer-logged-in');
  }

  function getReturnToUrl() {
    return window.location.pathname + window.location.search;
  }

  function setMessage(root, message, type) {
    var messageEl = root.querySelector('[data-enquiry-message]');
    if (!messageEl) return;

    messageEl.hidden = !message;
    messageEl.textContent = message || '';
    messageEl.classList.toggle('newsletter__message--error', type === 'error');
    messageEl.classList.toggle('newsletter__message--success', type === 'success');
  }

  function showStep(root, step) {
    root.querySelectorAll('[data-enquiry-step]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-enquiry-step') !== step;
    });
    root.dataset.enquiryStep = step;
  }

  function closeEnquiryDialog(root) {
    var dialog = root && root.closest('dialog');
    var popup = root && root.closest('popup-component');

    if (popup && typeof popup.popupClose === 'function') {
      popup.popupClose();
      return;
    }

    if (dialog && dialog.open) {
      dialog.close();
    }
  }

  function waitForOtpPlusModal(timeoutMs) {
    return new Promise(function (resolve) {
      var start = Date.now();

      function check() {
        var googleBtn = document.querySelector(
          '#otp-nca-account-modal [aria-label="Continue with Google"], #otp-nca-account-modal .otp-btn--google'
        );
        var modal = document.querySelector(
          '#otp-nca-account-modal .otp-account-modal, #otp-nca-account-modal .otp-account-modal-backdrop'
        );

        if (googleBtn || modal) {
          resolve({ googleBtn: googleBtn, modal: modal });
          return;
        }

        if (Date.now() - start >= timeoutMs) {
          resolve(null);
          return;
        }

        window.requestAnimationFrame(check);
      }

      check();
    });
  }

  function openOtpPlusModal(preferGoogle) {
    return new Promise(function (resolve) {
      var existing = document.querySelector(
        '#otp-nca-account-modal .otp-account-modal-backdrop, #otp-nca-account-modal .otp-account-modal'
      );

      function afterOpen() {
        waitForOtpPlusModal(2500).then(function (result) {
          if (preferGoogle && result && result.googleBtn) {
            result.googleBtn.click();
          }
          resolve(!!result);
        });
      }

      if (existing) {
        afterOpen();
        return;
      }

      var link = document.createElement('a');
      link.href = '/account/login';
      link.setAttribute('aria-hidden', 'true');
      link.tabIndex = -1;
      link.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;pointer-events:none;';
      document.body.appendChild(link);

      // OTP+ listens on capture-phase clicks for account login links
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          button: 0,
        })
      );

      window.setTimeout(function () {
        if (link.parentNode) link.parentNode.removeChild(link);
      }, 0);

      afterOpen();
    });
  }

  function startOtpPlusFromEnquiry(root, preferGoogle) {
    rememberReturnUrl(preferGoogle ? 'enquiry_google' : 'enquiry_phone');
    setMessage(root, '', 'success');
    closeEnquiryDialog(root);

    window.setTimeout(function () {
      openOtpPlusModal(preferGoogle).then(function (opened) {
        if (opened) return;

        // Fallback if OTP+ app embed is off
        window.location.href =
          '/customer_authentication/login?return_to=' +
          encodeURIComponent(getReturnToUrl());
      });
    }, 120);
  }

  function rememberReturnUrl(source) {
    try {
      sessionStorage.setItem(
        'mandira_signup_pending',
        JSON.stringify({
          returnUrl: getReturnToUrl(),
          source: source || 'enquiry',
        })
      );
    } catch (error) {
      /* ignore storage errors */
    }
  }

  function initForm(root) {
    if (!root || root.dataset.enquirySignInInit === 'true') return;
    root.dataset.enquirySignInInit = 'true';

    if (isCustomerLoggedIn()) {
      showStep(root, 'success');
      return;
    }

    showStep(root, 'details');

    root.querySelectorAll('[data-enquiry-otp-phone]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        startOtpPlusFromEnquiry(root, false);
      });
    });
  }

  function openEnquiryPopup(options) {
    options = options || {};
    var schedule = document.querySelector('[data-enquiry-popup-schedule]');
    if (!schedule) return false;

    var popupComponent = schedule.querySelector('popup-component');
    var dialog = schedule.querySelector('dialog');
    if (!popupComponent || !dialog || typeof popupComponent.popupOpen !== 'function') {
      return false;
    }

    var root = schedule.querySelector('[data-enquiry-sign-in]');
    if (root && options.resetToDetails) {
      showStep(root, 'details');
    }

    if (root && options.message) {
      setMessage(root, options.message, options.messageType || 'success');
    }

    if (!dialog.open) {
      popupComponent.popupOpen();
    }

    return true;
  }

  function getProductAddButton(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-add-to-cart], [data-add-to-cart-bar]');
  }

  function productFormIsValid(button) {
    var form =
      (button && button.closest('form')) ||
      document.querySelector('form[data-product-form]');
    if (!form) return true;
    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }
    return true;
  }

  function shouldGateProductAddToCart(button) {
    if (window.__mandiraSkipAddToCartGate) return false;
    if (window.__mandiraAddToCartGateDismissed) return false;
    if (isCustomerLoggedIn()) return false;
    if (!document.body.classList.contains('template-product')) return false;
    if (!button || button.disabled) return false;
    return productFormIsValid(button);
  }

  function clearPendingAddToCart() {
    window.__mandiraPendingAddToCartButton = null;
  }

  function dismissAddToCartGate() {
    if (!window.__mandiraPendingAddToCartButton) return;
    clearPendingAddToCart();
    window.__mandiraAddToCartGateDismissed = true;
  }

  function gateProductAddToCart(button) {
    rememberReturnUrl('add_to_cart');
    window.__mandiraPendingAddToCartButton = button;

    if (
      !openEnquiryPopup({
        resetToDetails: true,
        message: 'Sign in for 10% off, or close and click Add to Cart again.',
        messageType: 'success',
      })
    ) {
      clearPendingAddToCart();
      openOtpPlusModal(false).then(function (opened) {
        if (!opened) {
          window.location.href =
            '/customer_authentication/login?return_to=' +
            encodeURIComponent(getReturnToUrl());
        }
      });
    }
  }

  function initAddToCartGate() {
    if (window.__mandiraAddToCartGateInit) return;
    window.__mandiraAddToCartGateInit = true;

    document.addEventListener(
      'theme:cart:add',
      function (event) {
        var button = event.detail && event.detail.button ? event.detail.button : null;
        if (!shouldGateProductAddToCart(button)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        gateProductAddToCart(button);
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var button = getProductAddButton(event.target);
        if (!shouldGateProductAddToCart(button)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        gateProductAddToCart(button);
      },
      true
    );

    bindPopupCloseDismiss();

    document.addEventListener('theme:product:add', function () {
      window.__mandiraAddToCartGateDismissed = false;
    });
  }

  function bindPopupCloseDismiss() {
    var schedule = document.querySelector('[data-enquiry-popup-schedule]');
    if (!schedule) return;

    var dialog = schedule.querySelector('dialog');
    if (!dialog || dialog.dataset.dismissBound === 'true') return;

    dialog.dataset.dismissBound = 'true';

    function handleClose() {
      dismissAddToCartGate();
    }

    dialog.addEventListener('close', handleClose);
    dialog.addEventListener('theme:popup:onclose', handleClose);
  }

  function clearLegacyCookie(cookieName) {
    if (!cookieName) return;

    var expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = cookieName + '=; expires=' + expires + '; path=/';
    document.cookie =
      cookieName +
      '=; expires=' +
      expires +
      '; path=/; domain=' +
      window.location.hostname;
  }

  var POPUP_SESSION_START_KEY = 'mandira_enquiry_session_start';
  var POPUP_LAST_SHOWN_KEY = 'mandira_enquiry_last_shown';
  var POPUP_NEXT_AT_KEY = 'mandira_enquiry_next_at';

  function clearPopupTimer() {
    if (window.__mandiraEnquiryPopupTimerId) {
      window.clearTimeout(window.__mandiraEnquiryPopupTimerId);
      window.__mandiraEnquiryPopupTimerId = null;
    }
  }

  function getPopupStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setPopupStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      // Ignore private-mode / blocked storage.
    }
  }

  function getPopupSessionStart() {
    var start = getPopupStorage(POPUP_SESSION_START_KEY);
    if (!start) {
      start = String(Date.now());
      setPopupStorage(POPUP_SESSION_START_KEY, start);
    }
    return parseInt(start, 10) || Date.now();
  }

  function getPopupLastShown() {
    return parseInt(getPopupStorage(POPUP_LAST_SHOWN_KEY) || '0', 10) || 0;
  }

  function markPopupShown(repeatDelaySeconds) {
    var now = Date.now();
    setPopupStorage(POPUP_LAST_SHOWN_KEY, String(now));
    setPopupStorage(POPUP_NEXT_AT_KEY, String(now + repeatDelaySeconds * 1000));
  }

  function getNextPopupAt(initialDelaySeconds, repeatDelaySeconds) {
    var now = Date.now();
    var nextAt = parseInt(getPopupStorage(POPUP_NEXT_AT_KEY) || '0', 10) || 0;
    var lastShown = getPopupLastShown();

    if (nextAt > now) {
      return nextAt;
    }

    if (!lastShown) {
      nextAt = getPopupSessionStart() + initialDelaySeconds * 1000;
      if (nextAt <= now) {
        nextAt = now + initialDelaySeconds * 1000;
      }
    } else {
      nextAt = lastShown + repeatDelaySeconds * 1000;
      if (nextAt <= now) {
        nextAt = now + repeatDelaySeconds * 1000;
      }
    }

    setPopupStorage(POPUP_NEXT_AT_KEY, String(nextAt));
    return nextAt;
  }

  function scheduleEnquiryPopup(initialDelaySeconds, repeatDelaySeconds) {
    clearPopupTimer();

    if (window.Shopify && window.Shopify.designMode) return;
    if (isCustomerLoggedIn()) return;
    if (!document.querySelector('[data-enquiry-popup-schedule]')) return;

    var nextAt = getNextPopupAt(initialDelaySeconds, repeatDelaySeconds);
    var delayMs = Math.max(0, nextAt - Date.now());

    window.__mandiraEnquiryPopupTimerId = window.setTimeout(function () {
      if (isCustomerLoggedIn()) return;

      openEnquiryPopup();
      markPopupShown(repeatDelaySeconds);
      scheduleEnquiryPopup(initialDelaySeconds, repeatDelaySeconds);
    }, delayMs);
  }

  function initPopupSchedule() {
    var schedule = document.querySelector('[data-enquiry-popup-schedule]');
    if (!schedule) return;

    function boot() {
      if (window.Shopify && window.Shopify.designMode) return;
      if (isCustomerLoggedIn()) return;

      clearLegacyCookie(schedule.getAttribute('data-legacy-cookie'));

      var initialDelay = parseInt(schedule.getAttribute('data-initial-delay'), 10);
      var repeatDelay = parseInt(schedule.getAttribute('data-repeat-delay'), 10);

      if (isNaN(initialDelay) || initialDelay < 0) initialDelay = 10;
      if (isNaN(repeatDelay) || repeatDelay < 60) repeatDelay = 210;

      getPopupSessionStart();
      scheduleEnquiryPopup(initialDelay, repeatDelay);
    }

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('popup-component').then(boot).catch(boot);
    } else {
      boot();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-enquiry-sign-in]').forEach(initForm);
    initPopupSchedule();
    initAddToCartGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
